import { groupBy } from "lodash";

import { LISCase } from "pwapi";

import { useAppSelector } from "app/hooks";

export const useExternalLabForLabStain = (lab_stain_id?: number) => {
  const orderLabStain = useAppSelector(({ labStains }) =>
    labStains[lab_stain_id || -1] ? labStains[lab_stain_id || -1] : undefined
  );
  if (!orderLabStain) return undefined;

  const externalStain = useAppSelector(({ externalLabStains }) =>
    externalLabStains[orderLabStain?.external_lab_stain_id || -1]
      ? externalLabStains[orderLabStain?.external_lab_stain_id || -1]
      : undefined
  );
  if (!externalStain) return undefined;

  const externalLab = useAppSelector(({ externalLabs }) =>
    externalLabs[externalStain?.external_lab_id || -1]
      ? externalLabs[externalStain?.external_lab_id || -1]
      : undefined
  );

  return externalLab;
};

export const useGroupedOrdersByExternalLab = (
  lab_orders: LISCase["lab_orders"]
) => {
  const { labStains, externalLabStains } = useAppSelector((state) => state);

  return groupBy(lab_orders, (order) => {
    const lab_stain_id = order?.lab_stain_id;

    const orderLabStain = labStains[lab_stain_id || -1]
      ? labStains[lab_stain_id || -1]
      : undefined;

    const externalStain = externalLabStains[
      orderLabStain?.external_lab_stain_id || -1
    ]
      ? externalLabStains[orderLabStain?.external_lab_stain_id || -1]
      : undefined;

    return externalStain?.external_lab_id || 0;
  });
};
